<template>

    <ui-view class="view-overview-period">

        <ui-heading title="Overzicht per periode" icon="magicon-calendar"/>

        <ui-panel class="overview-settings">
            <div class="dates">
                <div class="start-date">
                    <span class="label">Startdatum</span>
                    <ui-date-input v-model="startDate"/>
                </div>
                <div class="start-date">
                    <span class="label">Einddatum</span>
                    <ui-date-input v-model="endDate"/>
                </div>
            </div>
            <div class="filter">
                <span class="label">Pas filters toe</span>
                <ui-filter-button :options="filterOptions" v-model="filters"/>
            </div>
            <div class="create">
                <ui-button
                    color="positive"
                    icon="magicon-reload-2"
                    @click="execute = true"
                    :loading="execute">Creëer overzicht</ui-button>
            </div>
        </ui-panel>


        <div class="results spinner-fill has-spinner">

            <span class="placeholder-full" v-if="parcels != null && !filteredParcels.length">Er zijn geen resultaten gevonden</span>
            <pm-parcel-detail
                v-else
                v-for="parcel in filteredParcels"
                :parcel="parcel"
                :key="parcel.id"
                :sections="parcel.sections.items"
                collapsible
                :type="filters.type"
                :start-date="startDate"
                :end-date="endDate"
            />

            <core-spinner :visible="loading" :overlay="parcels !== null"/>
        </div>
    </ui-view>

</template>

<script>

import Vue from 'vue';
import moment from 'moment';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import ActionEnum from 'common/enums/ActionType';
import ActionFilter from 'common/filters/actionType';

import AllParcelsQuery from 'gql/queries/OverviewPeriod/AllParcels.gql';

import ParcelDetail from 'app/components/ui/ParcelDetail.vue';

@Component({

    name: 'OverviewPeriod',
    components: {
        'pm-parcel-detail': ParcelDetail
    },
    apollo: {
        parcels: createQuery(AllParcelsQuery, {

            skip() {

                return !this.execute;
            },

            variables() {

                return {
                    startDate: this.startDate,
                    endDate: this.endDate
                };
            },

            response() {

                this.execute = false;
            }
        })
    }
})
export default class OverviewPeriod extends Vue
{
    loading = 0;
    execute = false;

    filters = {};

    parcels = null;
    startDate = moment().startOf('day').subtract(1, 'year').format('YYYY-MM-DD HH:mm');
    endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm');

    breadcrumb(){

        return 'Overzicht per periode';
    }

    get filteredParcels() {

        if(!this.parcels) {
            return [];
        }

        return this.parcels.items.filter(parcel => {

            parcel.sections.items = parcel.sections.items.filter(section => !!section.actions.length);

            return !!parcel.sections.items.length;
        });
    }

    get filterOptions() {

        return [{
            title: 'Actie',
            key: 'type',
            options: [
                { label: ActionFilter(ActionEnum.HARVEST), value: ActionEnum.HARVEST },
                { label: ActionFilter(ActionEnum.FISHING_AUCTION), value: ActionEnum.FISHING_AUCTION },
                { label: ActionFilter(ActionEnum.SOWING), value: ActionEnum.SOWING },
                { label: ActionFilter(ActionEnum.SAMPLE), value: ActionEnum.SAMPLE },
                { label: ActionFilter(ActionEnum.TREATMENT), value: ActionEnum.TREATMENT },
                { label: ActionFilter(ActionEnum.TREATMENT_SOWING), value: ActionEnum.TREATMENT_SOWING },
                { label: ActionFilter(ActionEnum.TREATMENT_HARVEST), value: ActionEnum.TREATMENT_HARVEST }
            ]
        }];
    }
}

</script>